import { render, staticRenderFns } from "./financescandinavia.vue?vue&type=template&id=651e8347&"
import script from "./financescandinavia.vue?vue&type=script&lang=js&"
export * from "./financescandinavia.vue?vue&type=script&lang=js&"
import style0 from "./financescandinavia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports